import React from 'react';
import { ICustomerBilletItem } from '../../../../../store/ducks/download-area/types';
import Table from '../../../../../components/Table';
import { formatCurrency } from '../../../../../utils/formatNumbers';
import moment from 'moment';
import { Tag } from '@gerdau/hefesto-mais-web';
import { Variants } from '@gerdau/hefesto/_shared/types';
import { Container } from './styles';
import BilletDownloadButton from './BilletDownloadButton';
import { EInvoiceStatus } from '../../../../../store/ducks/invoices/types';
interface IBilletTabContentTable {
  data: ICustomerBilletItem[];
}

const BilletTabContentTable: React.FC<IBilletTabContentTable> = ({ data }) => {
  const variantStatus = (status: EInvoiceStatus) => {
    switch (status) {
      case EInvoiceStatus.CLOSED:
        return 'success';
      case EInvoiceStatus.DUE:
        return 'danger';
      case EInvoiceStatus.WILL_DUE:
        return 'warning';

      default:
        return '';
    }
  };

  const getColumns = () => {
    const columns = [
      {
        title: 'Nº do pedido',
        dataIndex: 'orderNumber',
        sorter: (a: ICustomerBilletItem, b: ICustomerBilletItem) =>
          a.orderNumber.localeCompare(b.orderNumber),
        render: (text: string) => <span>{text}</span>
      },
      {
        title: 'Valor total',
        dataIndex: 'totalValue',
        sorter: (a: ICustomerBilletItem, b: ICustomerBilletItem) =>
          +a.totalValue.toString().replace(',', '') -
          +b.totalValue.toString().replace(',', ''),
        render: (totalValue: string) => (
          <>
            {' '}
            {totalValue === 'Indisponível'
              ? totalValue
              : 'R$ ' + formatCurrency(totalValue.toString().replace(/,/g, ''))}
          </>
        )
      },
      {
        title: 'Faturamento',
        dataIndex: 'billingDate',
        sorter: (a: ICustomerBilletItem, b: ICustomerBilletItem) =>
          moment(a.billingDate, 'YYYY-MM-DD').toDate().getTime() -
          moment(b.billingDate, 'YYYY-MM-DD').toDate().getTime(),
        render: (date: string) => (
          <span>
            {date ? moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY') : '-'}
          </span>
        )
      },
      {
        title: 'Vencimento',
        dataIndex: 'dueDate',
        sorter: (a: ICustomerBilletItem, b: ICustomerBilletItem) =>
          moment(a.dueDate, 'YYYY-MM-DD').toDate().getTime() -
          moment(b.dueDate, 'YYYY-MM-DD').toDate().getTime(),
        render: (date: string) => (
          <span>
            {date ? moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY') : '-'}
          </span>
        )
      },
      {
        title: 'Status',
        dataIndex: 'status',
        sorter: (a: ICustomerBilletItem, b: ICustomerBilletItem) =>
          a.status.localeCompare(b.status),
        render: (status: EInvoiceStatus) => (
          <Tag
            variant={
              status.replace(status, variantStatus(status)) as Exclude<
                Variants,
                'secondary' | 'tertiary'
              >
            }
          >
            {status}
          </Tag>
        )
      },
      {
        title: 'Download',
        dataIndex: '',
        render: (billetData: ICustomerBilletItem) => (
          <BilletDownloadButton billetData={billetData} />
        )
      }
    ];

    return columns;
  };

  return (
    <Container>
      <Table columns={getColumns()} data={data} hasPagination />
    </Container>
  );
};

export default BilletTabContentTable;
